/**
 *  Announcement‑bar directional slider helper
 *  -------------------------------------------------
 *  • Matches animation direction to the arrow clicked
 *  • Creates an infinite loop with smooth wrap‑around
 *  • Removes Dawn’s native click handlers so only our
 *    custom motion runs (prevents double scrolls)
 *  -------------------------------------------------
 */

document.addEventListener('DOMContentLoaded', () => {
  /* ----- Locate DOM elements ----- */
  const wrapper    = document.querySelector('.announcement-bar-slider');
  if (!wrapper) return;

  const sliderElm  = wrapper.querySelector('[id^="Slider-"]'); // Dawn’s default ID
  if (!sliderElm) return;

  /* Strip Dawn’s click listeners by cloning arrow buttons */
  const resetButtonListeners = (btn) => {
    if (!btn) return null;
    const clone = btn.cloneNode(true);   // same markup, zero listeners
    btn.replaceWith(clone);
    return clone;
  };

  let btnPrev = resetButtonListeners(
    wrapper.querySelector('.slider-button--prev')
  );
  let btnNext = resetButtonListeners(
    wrapper.querySelector('.slider-button--next')
  );

  /* ----- Build infinite loop ----- */
  const slideCount = sliderElm.children.length;
  if (slideCount < 2) return;            // nothing to do with 1 slide

  // Clone first & last slides
  const firstClone = sliderElm.children[0].cloneNode(true);
  const lastClone  = sliderElm.children[slideCount - 1].cloneNode(true);
  sliderElm.appendChild(firstClone);
  sliderElm.insertBefore(lastClone, sliderElm.firstChild);

  // Start on the *real* first slide (index 1 after prepending lastClone)
  let idx        = 1;
  const slideW   = sliderElm.children[1].offsetWidth;
  sliderElm.scrollLeft = slideW;         // jump instantly (no animation)

  /* ----- Scroll helper ----- */
  const goTo = (newIdx) => {
    sliderElm.style.scrollBehavior = 'smooth';
    sliderElm.scrollLeft = slideW * newIdx;
    idx = newIdx;

    // After smooth scroll ends, snap if we’re on a clone
    const onScrollEnd = () => {
      const max = slideCount;

      if (idx === 0) {                   // we’re on clone of last
        sliderElm.style.scrollBehavior = 'auto';
        sliderElm.scrollLeft = slideW * max;
        idx = max;
      }
      if (idx === max + 1) {             // we’re on clone of first
        sliderElm.style.scrollBehavior = 'auto';
        sliderElm.scrollLeft = slideW;
        idx = 1;
      }
      sliderElm.removeEventListener('scrollend', onScrollEnd);
    };

    // Use native scrollend where supported, fallback to timeout
    if ('onscrollend' in document) {
      sliderElm.addEventListener('scrollend', onScrollEnd, { passive: true });
    } else {
      setTimeout(onScrollEnd, 400);      // ~duration of smooth scroll
    }
  };

  /* ----- Arrow handlers (only our custom logic now) ----- */
  btnPrev &&
    btnPrev.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(idx - 1);                     // move right ← left
    });

  btnNext &&
    btnNext.addEventListener('click', (e) => {
      e.preventDefault();
      goTo(idx + 1);                     // move left → right
    });
});